<template>
  <div id="word">
    <div class="container">
      <div class="header">
        Word版BDA小助手
      </div>
      <table class="tb">
        <tr>
          <td style="width: 600px">
            <tr class="row">
              <td class="name">软件语言：</td>
              <td class="value">简体中文</td>
              <td class="name">软件大小：</td>
              <td class="value">{{ fileSize }}MB</td>
            </tr>
            <tr class="row">
              <td class="name">软件热度：</td>
              <td class="value">
                <el-rate
                  v-model="value">
                </el-rate>
              </td>
              <td class="name">支持系统：</td>
              <td class="value">Windows10|Windows11</td>
            </tr>
            <tr class="row">
              <td class="name">软件版本：</td>
              <td class="value">V{{ fileVersion }}</td>
              <td class="name">更新日期：</td>
              <td class="value">{{ fileDate }}</td>
            </tr>
            <div class="btn">
              <el-button type="primary" icon="el-icon-download" round @click="handle_download">&nbsp;免费下载</el-button>
            </div>
          </td>
          <td style="padding-right: 20px;">
            <el-image :src="src_try" style="height: 250px;width: 320px"></el-image>
          </td>
        </tr>
      </table>
    </div>
    <div class="container">
      <div class="title">
        功能介绍
      </div>
      <div class="content">
        <el-image :src="src"></el-image>
        <div class="description">
          在Word中增加插件功能【BDA小助手】，实现图片处理、排版处理表格工具以及插入签名等自定义功能，为标书制作、项目文档制作等提供一键
          批量处理功能，减少重复性操作，提升工作效率。
          <p><span class="key_word">图片处理：</span>实现批量设置图片大小、默认图片大小，可选择是否给图片添加边框。</p>
          <p><span class="key_word">排版处理：</span>（1）一键设置表格格式，可选择技术文档、汇报类文档两种不同的标题样式；
            （2）按条件插入分页；（3）一键插入目录，可设定默认格式；（4）一键插入页码，可设置默认格式；（5）一键实现将标题自动编号
            格式转换成文本格式，实现手动编号；（6）一键删除表格样式中的文本编号，实现自动编号；（7）一键删除空行。</p>
          <p><span class="key_word">表格工具：</span>（1）在word表格中，实现一键横向、纵向求和、平均值、相乘公式功能，并可以设置小数点；
            （2）一键设置表格样式，可自定义设置默认格式；（3）一键实现3字中文名字对齐；（4）一键替换Excel的换行符；（5）一键插入序号。</p>
          <p><span class="key_word">自定义功能：</span>（1）一键插入印章图片；（2）一键插入签名图片；（3）自动将数字的人民币金额转换成
            中文大写格式；（4）一键清除换行符；（5）一键删除空格。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import img from '@/assets/images/word.png'
import img_try from '@/assets/images/try.png'
import { getDownload, getVersion } from '@/api'
import { urlParam } from '@/utils/url'
export default {
  name: 'Word',
  components: {
    // HelloWorld,
    // FixedHeader
  },
  data() {
    return {
      tableData: [],
      src: img,
      src_try: img_try,
      value: 5,
      fileSize: '',
      fileDate: '',
      fileVersion: '',
      fileUrl: '',
      fileId: '',
      param: {},
      oname: 'VST002'
    }
  },
  created() {
    // 获取链接的参数
    this.param = urlParam
    // 获取版本信息
    this.handle_getVersion()
  },
  mounted() {
  },
  methods: {
    handle_download() {
      // this.visible = true
      // const filePath = baseURL + 'download/BooleanDA文档小助手_V1.3.0.0.rar'
      const filePath = this.fileUrl
      const link = window.document.createElement('a')
      link.style.display = 'none'
      // link.href = url
      link.href = filePath
      // link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      this.$message({
        message: '恭喜你，文件已开始下载！',
        type: 'success'
      })
      //
      // Math.random()*(max-min)+min),生成10-100的随机数
      const timestamp = new Date().getTime().toString() + Math.round(Math.random() * 90 + 10).toString()
      var params = {
        'id': this.fileId,
        'timestamp': timestamp
      }
      getDownload(params).then((res) => {
        console.log('更新返回成功')
        console.log(res)
        if (res['code'] === 200) {
          console.log('更新成功' + res['data'])
        } else {
          // 提示信息
          console.log('fail')
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    handle_getVersion() {
      const timestamp = new Date().getTime().toString() + Math.round(Math.random() * 90 + 10).toString()
      var params = {
        'id': this.oname,
        'timestamp': timestamp
      }
      getVersion(params).then((res) => {
        console.log('获取版本返回数据')
        console.log(res)
        if (res['code'] === 200) {
          console.log('获取数据成功')
          console.log(res.data)
          this.fileVersion = res['data']['fileVersion']
          this.fileUrl = res['data']['fileUrl']
          this.fileSize = res['data']['fileSize']
          this.fileDate = res['data']['fileDate']
          this.fileId = 'VST002V' + this.fileVersion.replaceAll('.', '')
        } else {
          // 提示信息
          console.log('fail')
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#word {
  position: relative;
  width: calc(100vw - 60px);
  //height: calc(100vh - 220px);
  top: 45px;
  padding: 30px;
  background: #f0f0f0;
}
.container{
  background: white;
  margin-left: calc((100vh - 475px) / 2);
  margin-right: calc((100vh - 475px) / 2);
  margin-bottom: 10px;
  border-radius: 10px;
  padding: 10px;
}
.header{
  text-align: left;
  margin-left: 20px;
  margin-top: 20px;
  font-size: 22px;
  //color: #606266;
  color: #409EFF;
  padding-left: 10px;
  //字体与下划线的距离
  padding-bottom:8px;
  border-bottom: 2px solid rgba(225, 224, 224, 0.5);

}
.tb{
  padding-left: 10px;
  padding-top: 10px;
  font-size: 16px;
  .row{
    height: 40px;
  }
  .name{
    width: 120px;
    color: rgba(129, 128, 128, 0.9);
    text-align: right;
  }
  .value{
    width: 120px;
    color: #606266;
    text-align: left;
  }
}
.title{
  text-align: center;
  margin-left: 20px;
  font-size: 18px;
  //color: #606266;
  color: #409EFF;
  //字体与下划线的距离
  padding-bottom:5px;
  border-bottom: 2px solid #409EFF;
  width: 90px;
}
.content{
  padding: 15px;
}
.description{
  text-align: left;
  //首行缩进2个字符
  text-indent:24px;
  line-height: 28px;
  margin-top: 10px;
  margin-bottom: 10px;
  .key_word{
    font-weight: bold;
  }
}
.btn{
  margin-left: 50px;
  margin-top: 30px;
  margin-bottom: 20px;
}
.el-button--primary {
  display: block;
  color: #FFF;
  background-color: rgba(0, 63, 255, 0.8);
  border-color: rgba(0, 63, 255, 0.8);
  box-shadow: 1px 10px 20px rgba(242, 243, 248, 0.5);
  line-height: 34px;
  padding: 0 20px;
  height: 70px;
  width: 280px;
  font-size: 23px;
  font-weight: bold;
}
.el-button--primary:focus,
.el-button--primary:hover {
  color: #FFF;
  background-color: #1E90FF;
  border-color: #1E90FF;
  line-height: 34px;
  padding: 0 20px;
  height: 70px;
  width: 280px;
  font-size: 25px;
}
.el-button--primary:active {
  color: #FFF;
  background-color: #1E90FF;
  border-color: #1E90FF;
  line-height: 34px;
  padding: 0 20px;
  height: 70px;
  width: 280px;
  font-size: 23px;
}
</style>
